export default __webpack_public_path__ + "static/media/Cover.d33b7749.png";